import { AppMessages, LocaleAppMessages } from '../types';

const enMessages: LocaleAppMessages = {
  [AppMessages.btnLogIn]: 'Log In',
};

export default enMessages;
